import { render } from "./Widget2.vue?vue&type=template&id=83cdc234&ts=true"
import script from "./Widget2.vue?vue&type=script&lang=ts"
export * from "./Widget2.vue?vue&type=script&lang=ts"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__